<template>
  <nav class="flex flex-col">
    <slot></slot>
  </nav>
</template>
